
import { Options, Vue } from 'vue-class-component';
import { Watch } from 'vue-property-decorator';

@Options({
  props: {
    fileInput: {},
    disabled: Boolean,
  },
  emits: ['update:fileInput'],
  components: {
  }
})


export default class FileSelector extends Vue {
  fileInput!: File;
  disabled!: boolean;

  public id: string = this.$guid();
  private isOversize = false;

  private selectedFile!: File;
  private selectedFileName = '';
  private correctFileType = true;

  @Watch('fileInput')
  public onFileInputChaged(val: any, oldVal: any) {
    this.selectedFile = this.fileInput;
    if (!val.name) {
      const elm: any = this.$refs.fileSelector;
      elm.value = null;
      this.selectedFileName = '';
      console.log(val);
    }
  }

  private onFileSelected(event: any) {
    if (event.target.files[0]) {
      this.selectedFile = event.target.files[0];
      this.selectedFileName = this.selectedFile.name;
      this.isOversize = this.selectedFile && (this.selectedFile.size / 1024000) > 20 as any;
      this.correctFileType = this.selectedFile && this.selectedFile.type === 'application/pdf';
      if (!this.isOversize && this.correctFileType) {
        this.$emit('update:fileInput', this.selectedFile);
      } else {
        this.$emit('update:fileInput', '');
      }
    }
  }

  private selectFile(e: any) {
    if (!this.disabled) {
      e.target.blur();
      const elm: HTMLElement = this.$refs.fileSelector as HTMLElement;
      elm.click();
    }
  }

  public $guid() {
    const S4 = () => {
      // tslint:disable-next-line: no-bitwise
      return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    };
    // then to call it, plus stitch in '4' in the third group
    // tslint:disable-next-line: max-line-length
    return (S4() + S4() + '-' + S4() + '-4' + S4().substr(0, 3) + '-' + S4() + '-' + S4() + S4() + S4()).toLowerCase();
  }

}
